import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SettingsComponent } from './settings';
import { XguardService, XloginGuard } from '@area/user';


const routes: Routes = [
	{
		path: '',
		redirectTo: 'inicio',
		pathMatch: 'full'
	},
	{
		path: 'login',
		// loadChildren: 'app/login/login.module#LoginModule',
		loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
		canActivate: [XloginGuard]
	},
	{
		path: 'configuracion',
		component: SettingsComponent,
		data: {
			title: 'Configuracion'
		}
	},
	{
		path: 'cursos',
		loadChildren: () => import('./courses/courses.module').then(m => m.CoursesModule),
	},
	{
		path: 'usuario',
		loadChildren: () => import('./profiles/profiles.module').then(m => m.ProfilesModule),
		canActivate: [XguardService],
		data: {
			title: 'Usuario'
		}
	},
	{
		path: 'certificados',
		loadChildren: () => import('./certificado/certificado.module').then(m => m.CertificadoModule),
		data: {
			title: 'Certificados'
		}
  	},
	{
		path: 'admin',
    	loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
    	canActivate: [XguardService],
		data: {
			title: 'admin'
		}
	},
	{
		path: 'editProfile',
		loadChildren: () => import('./profiles/edit-profile/editProfile.module').then(m => m.EditProfileModule),
		canActivate: [XguardService],
		data: {
			title: 'admin'
		}
	},
	{
		path: '**',
		redirectTo: 'inicio'
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
	providers: [XguardService, XloginGuard],
})
export class AppRoutingModule { }
